export const normalizeIndianMobileNumber = (value: string) => {
  const digits = (value || "").replace(/\D/g, "");

  if (!digits) {
    return "";
  }

  if (digits.length <= 10) {
    return digits;
  }

  return digits.slice(-10);
};
